module.exports = __webpack_public_path__ + "static/media/WCCE-Color-Logo.cf2a0aa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/WCCE-Color-Logo.png
// module id = 908
// module chunks = 0